import { BluetoothPairingGuide, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getBTPairingGuides = async (
  groupId: number,
  locale: string,
  platform?: string
): Promise<BluetoothPairingGuide[]> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.BluetoothPairingGuides}${platform ? '/' + encodeURIComponent(platform) : ''}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<BluetoothPairingGuide[]>(url);

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching BT Pairing Guides:`, error);
    return [];
  }
};
